import { useApiClient } from '@/hooks/api/useApi/useApiClient';
import { IRecoverPasswordSchemaResponse } from '@/hooks/api/useRecoverPasswordFormSchema/useRecoverPasswordFormSchema.interfaces';

export const useRecoverPasswordFormSchema = () => {
    const { fetch, loading } = useApiClient<IRecoverPasswordSchemaResponse>();

    const getSchema = async () =>
        await fetch({
            url: '/schema/recover-password.json',
            method: 'GET',
        });

    return {
        getSchema,
        loading,
    };
};
